import * as VueRouter from 'vue-router';

function getBasePath(area) {
    const pathname = window.location.pathname;
    if (!area) {
        return pathname;
    }
    const index = pathname.toLowerCase().indexOf(area.toLowerCase());
    return pathname.substring(0, index + area.length);
}

export function createBaseRouter(routes, area) {
    const basePath = getBasePath(area);

    return VueRouter.createRouter({
        history: VueRouter.createWebHistory(basePath),
        routes,
    });
};